import * as TK from 'pages/EditPostPage/translations/constants';
import { Translations } from 'translations/types';

export const editPostPageEnUsLocale: Translations = {
  [TK.EDIT_POST_PAGE_TITLE]: 'Edit Post',
  [TK.EDIT_POST_PAGE_SUBMIT_BUTTON_LABEL]: 'Save',
};
